import React from "react";
import "./App.css";
import { FEATURES } from "./mock";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Visual from "./components/Visual";
import Music from "./components/Music";
import Merch from "./components/Merch";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Connect from "./components/Connect";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App bg-[#0a0410] min-h-screen">
      <Header />
      <main>
        <Hero />
        <Visual />
        <Music />
        {FEATURES.storeEnabled && <Merch />}
        <About />
        <Gallery />
        <Connect />
      </main>
      <Footer />
    </div>
  );
}

export default App;
